export default __webpack_public_path__ + "static/media/expansionCL.4a195a65.webp";